import * as R from 'ramda';
import {
  ApiReducer,
  makeApiAction,
  makeApiReducer,
  RsaaTypes,
} from '../../../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../../../core/redux/IAppState';
import { apiGetRedemptionEntitlements } from '../../../../core/redux/api/endpoints';
import { ACTION_TYPE } from '../../../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../../../core/redux/api/circuitBreaker/module';
import { Entitlement } from '../../models';
import { updateGuest } from '../../../module';
import { normalizeEntitlements } from '../../module';


export const KEY_ACTION = ACTION_TYPE.GET_FNF_ENTITLEMENTS_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.GET_FNF_ENTITLEMENTS_REQUEST,
  ACTION_TYPE.GET_FNF_ENTITLEMENTS_RESPONSE,
  ACTION_TYPE.GET_FNF_ENTITLEMENTS_ERROR,
];


/**
 * Makes an action that can be dispatched to get a guest's Friends and Family entitlements (as opposed to Direct to
 * Window or Direct to Lift entitlements). A response will include things like the guest's F&F history redemption
 * history.
 */
export const getFnFEntitlementsAction = (guestId: string) => makeApiAction(
  {
    method:   'GET',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: state => apiGetRedemptionEntitlements(
      guestId,
      state.resortToolsConfig.fnfCategoryId,
      state.resortToolsConfig.enableRedemptionDisplayOnly,
      state.selectedResort.resortAbbreviation,
      true,         // load fnf redemptions for all resorts
      ),
    types:    ACTIONS.map(action => ({ type: action, meta: { guestId } })) as RsaaTypes,
    bailout:  (state: IAppState) => !!getLoading(state, guestId, ACTION_TYPE.GET_FNF_ENTITLEMENTS_REQUEST)
                                    || hasTrippedBreaker(state, ACTION_TYPE.GET_FNF_ENTITLEMENTS_REQUEST),
  },
);


const reducer: ApiReducer<Entitlement[]> = (state, action, error, isLoading, payload) => {
  const guestId = action.meta.guestId;

  if (isLoading) {
    return addLoading(state, guestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, guestId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, guestId, KEY_ACTION);

  return updateGuest(noLoadingOrError, guestId, R.assocPath([ 'friendsAndFamily' ], normalizeEntitlements(payload)));
};


export const getFnfEntitlementsReducer = makeApiReducer<Entitlement[]>(ACTIONS, KEY_ACTION, reducer);
